/**
 * Collects allowed param keys from input_schema.properties and allOf
 * (required, then.required, then.properties).
 */
export function collectAllowedKeys(inputSchema) {
  const allowed = new Set(Object.keys(inputSchema.properties))
  const allOf = inputSchema.allOf || []
  allOf.forEach((entry) => {
    if (entry.required) {
      entry.required.forEach(key => allowed.add(key))
    }

    const then = entry.then
    if (then && typeof then === 'object') {
      if (then.required) {
        then.required.forEach(key => allowed.add(key))
      }
      if (then.properties) {
        Object.keys(then.properties).forEach(key => allowed.add(key))
      }
    }
  })

  return allowed
}
